import React, { lazy } from "react";

const LazyCreateTemplate = lazy(() => import("./CreateTemplate"));

const CreateTemplate = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyCreateTemplate {...props} />;

export default CreateTemplate;
